import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import GeoUtils from '../geoUtils.js';
import Utils3D from '../../utils/utils3D.js';

const DEBUG_VISUALIZE_NORMALS = false;

export default class NodeSmoothNormals extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);
		this.addInput(PARAM_TYPE.FLOAT, 'smooth_angle', 45.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}
	
	getType()
	{ 
		return 'smoothNormals';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pGeoList = inputValues['geo'];
		if(!pGeoList || pGeoList.length === 0)
			return null;

		for(let pSrcMesh of pGeoList)
		{
			if(!pSrcMesh)
				continue;

			GeoUtils.recomputeNormals(pSrcMesh, inputValues['smooth_angle']);

			if(DEBUG_VISUALIZE_NORMALS)
			{
				let normalLines = Utils3D.debugShowNormals(pSrcMesh, scene);
				this.onMeshCreated(normalLines);
				normalLines.setEnabled(true);
			}
		}

		return pGeoList;
	}
}